import tagTester from './_tagTester.js';

export default tagTester('Number');



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/isNumber.js
// module id = 292
// module chunks = 8